import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/pc/HomeView.vue'
import Login from '../views/pc/login.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'home',
    component: Login
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
